import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import useApplicantStore from '../../../store/applicantStore/useApplicantStore';
import useDashboardStore from '../../../store/dashboardStore/useDashboardStore';
import { locator } from '../../../testing/e2e-locator/locator';

const IncomeSection = (): ReactNode => {
  const { t } = useTranslation();
  const {
    computed: { vehicleId },
  } = useDashboardStore();

  const {
    computed: {
      additionalIncomeAmount,
      additionalIncomeFrequency,
      additionalIncomeStatus,
      additionalIncomeType,
    },
  } = useApplicantStore();

  return (
    <span data-testid={locator.components.incomeSection.root}>
      <div className="head">
        <h3 data-testid={locator.components.incomeSection.h3}>
          {t('ApplicantReviewPage.additionalIncome')}
        </h3>
        <Link
          data-testid={locator.components.incomeSection.editLink}
          to={`/applicant/${vehicleId}/edit-income`}
        >
          {t('ApplicantReviewPage.edit')}
        </Link>
      </div>

      <ul>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.status')}</dt>
            <dd data-testid={locator.components.incomeSection.status}>
              {additionalIncomeStatus}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.type')}</dt>
            <dd data-testid={locator.components.incomeSection.incomeType}>
              {additionalIncomeType}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.amount')}</dt>
            <dd data-testid={locator.components.incomeSection.amount}>
              {additionalIncomeAmount}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.frequency')}</dt>
            <dd data-testid={locator.components.incomeSection.frequency}>
              {additionalIncomeFrequency}
            </dd>
          </dl>
        </li>
      </ul>
    </span>
  );
};

export default IncomeSection;
